import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initTelemetry } from "./lib/telemetry";
import { initSentry } from "./lib/sentry";

const clearLegacySiteCaches = async () => {
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if ("caches" in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }
};

// Initialize error tracking and telemetry (non-blocking)
initSentry();
initTelemetry();
clearLegacySiteCaches().catch(() => undefined);

// Initialize theme from localStorage or default to dark
const storedTheme = localStorage.getItem("theme");
if (storedTheme === "light") {
  document.documentElement.classList.remove("dark");
} else {
  document.documentElement.classList.add("dark");
  localStorage.setItem("theme", "dark");
}

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

// Conditionally wrap with ClerkProvider if key is available
const renderApp = async () => {
  const root = createRoot(document.getElementById("root")!);

  if (CLERK_PUBLISHABLE_KEY) {
    const { ClerkProvider } = await import("@clerk/clerk-react");
    root.render(
      <HelmetProvider>
        <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
          <App />
        </ClerkProvider>
      </HelmetProvider>
    );
  } else {
    console.warn("VITE_CLERK_PUBLISHABLE_KEY not set — running without auth");
    root.render(
      <HelmetProvider>
        <App />
      </HelmetProvider>
    );
  }
};

renderApp();
